module.exports = __webpack_public_path__ + "static/media/canari_logo.6c760816.png";